import { render } from "./trainingDatasetList.vue?vue&type=template&id=c08adcc0"
import script from "./trainingDatasetList.vue?vue&type=script&lang=js"
export * from "./trainingDatasetList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__